import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { StickyContainer } from 'react-sticky';

import SharedSlideoutWithRouter from '../../Slideout/SharedSlideoutWithRouter';
import Footer from './Footer';
import JobCurrentMatches from './JobCurrentMatches';
import JobInfo from './JobInfo';
import JobRibbon from './JobRibbon';
import JobTitleMatches from './JobTitleMatches';
import JobTitleSearch from './JobTitleSearch';
import LoadingIndicator from './LoadingIndicator';
import GradeContainer from './GradeContainer';
import InfoContainer from './InfoContainer';
import { hasQualityReportRating } from '../../lib/helpers/hasQualityReportRating';
import { getActions as getSurveyActions } from './reducers/surveys/surveyDetails';
import * as surveyActions from './reducers/surveys/surveyActions';
import * as addJobActions from './reducers/addJob';
import * as addJobUpldatedDetailsActions from './reducers/addJobUpdatedDetails';
import * as careerLevelsActions from './reducers/careerLevels';
import * as gradeChartActions from './reducers/marketRateChart.js';
import * as jobActions from './reducers/jobActions';
import * as jobCertificationsActions from './reducers/jobCertifications';
import * as jobFamilyActions from './reducers/jobFamilies';
import * as jobSkillsActions from './reducers/skillsByJobList';
import * as suggestCareerActions from './reducers/suggestCareer';
import * as suggestFamilyActions from './reducers/suggestFamily';
import * as structureListActions from './reducers/addJobStructureList';
import { actions as surveyListActions, loadJobDetails, loadDetailsChart } from './reducers/jobSurveyList';
import { isFeatureEnabled } from '../../FeatureFlags/FeatureFlagActions';
import { saveProfilesAnalyzed, resetScroll } from './reducers/jobDetails';

import './AddEditJobSlideout.scss';
import './jobCurrentMatchCard.scss';
import './jobSurveyList.scss';
import './jobTitleMatch.scss';

interface AddEditJobSlideoutProps extends RouteComponentProps {
  actions: any;
  addJob: any;
  addJobStructureList: any;
  addJobUpdatedDetails: any;
  app: any;
  careerLevels: any;
  history: any;
  isAdvancedSurveyManagementEnabled: boolean;
  jobCertifications: any;
  jobDescription: any;
  jobDetails: any;
  jobFamilies: any;
  jobFamily: string;
  jobSurveyList: any;
  marketRateChart: any;
  showYearsExperienceLabelUpdate: boolean;
  skillsByJobList: any;
  suggestCareer: any;
  suggestFamily: any;
  refreshJobTabData: Function;
  isQuickPriceJobEnabled: boolean;
  replacementTokens: Array<any>;
  useJobCodeKey: boolean;
  surveyDetails: any;
  isJdxEnabled: boolean;
}

const AddEditJobSlideout = class AddEditJobSlideout extends Component<
  AddEditJobSlideoutProps,
  { fileRejectReason: string }
> {
  constructor(props: AddEditJobSlideoutProps) {
    super(props);
    this.state = {
      fileRejectReason: ''
    };

    this.cancelUpload = this.cancelUpload.bind(this);
    this.getFileRejectReason = this.getFileRejectReason.bind(this);
    this.handleJobSearch = this.handleJobSearch.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.resetFileRejectReason = this.resetFileRejectReason.bind(this);
  }

  componentDidUpdate(prevProps: AddEditJobSlideoutProps, prevState: {}, snapshot: any) {
    const { actions, addJob, app, jobSurveyList } = this.props;
    if (addJob.orgJobId !== prevProps.addJob.orgJobId && app.basicProductName === 'MarketPay') {
      actions.loadDetailsPanel(addJob.orgJobId);
    }

    if (
      jobSurveyList.items.length !== prevProps.jobSurveyList.items.length &&
      prevProps.jobSurveyList.loading &&
      !jobSurveyList.loading &&
      app.basicProductName === 'MarketPay'
    ) {
      actions.saveJobAndUpdatePay(
        {
          orgJobTitle: addJob.orgJobTitle,
          orgJobCode: addJob.jobCode,
          workLocation: addJob.workLocationExact,
          orgJobId: addJob.orgJobId,
          jobDetails: this.props.jobDetails
        },
        {}
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: AddEditJobSlideoutProps) {
    if (
      nextProps &&
      nextProps.history &&
      nextProps.addJob.orgJobId &&
      nextProps.addJob.orgJobId !== '' &&
      !nextProps.addJob.editMode &&
      nextProps.addJob.panelVisible
    ) {
      // TODO: Test this still works
      const isActive = nextProps.history.location.pathname === '/jobs/detail/' + nextProps.addJob.orgJobId;
      if (!isActive && this.props.app.basicProductName !== 'MarketPay') {
        // The jobs is async added to elastic so this needs to be delayed and the user wont notice
        setTimeout(function() {
          nextProps.history.push('/jobs/detail/' + nextProps.addJob.orgJobId);
        }, 4000);
      }
    }
    return true;
  }

  close() {
    const { actions, refreshJobTabData } = this.props;
    if (refreshJobTabData) refreshJobTabData();
    this.resetFileRejectReason();
    actions.closeEditJobSlideout();
  }

  getJobStateClass() {
    const { addJob } = this.props;

    let currentStateClass = 'add-job--add';
    if (addJob.editJobTitleMode) {
      // editing an existing match
      currentStateClass = 'add-job--edit-match';
    } else {
      // not editing an existing match
      if (addJob.editMode) {
        // opening the edit job details slideout
        currentStateClass = 'add-job--edit';
      } else {
        // not opening the edit job details slideout, following intiail add-job flow
        if (addJob.jobWasEdited) {
          // after initial add-job flow, when user is still editing job details
          currentStateClass = 'add-job--add-edit-details';
        }
        if (addJob.searchLoaded && !addJob.jobWasEdited) {
          // after initial add-job flow, when user is picking match
          currentStateClass = 'add-job--add-match';
        }
      }
    }

    return currentStateClass;
  }

  getJobTransitionClass() {
    const { addJob } = this.props;

    let currentTransitionClass = '';
    if (addJob.searchLoading && !addJob.searchLoaded) {
      currentTransitionClass = 'add-job--is-loading-carousel';
    }
    if (addJob.searchLoaded && addJob.jobSavingStatus === 'Saving changes...') {
      // there must be a better way to reference jobSavingStatus but I don't know what it is.
      currentTransitionClass = 'add-job--saving-new-match';
    }

    return currentTransitionClass;
  }

  basicJobInfoSection() {
    const acceptedFileTypes = ['.RTF', '.TXT', '.DOC', '.DOCX', '.PDF'];
    const {
      actions,
      addJob,
      isQuickPriceJobEnabled,
      jobDetails,
      replacementTokens,
      useJobCodeKey,
      isJdxEnabled,
      app
    } = this.props;
    let replacement;
    if (useJobCodeKey) {
      const hasReplacementJCK =
        replacementTokens && replacementTokens.find(replacement => replacement.token === 'job_code_key_text');
      replacement = hasReplacementJCK
        ? replacementTokens.find(replacement => replacement.token === 'job_code_key_text').value
        : 'Job Code Key';
    }

    if (!addJob.formSections.jobDetails.display || addJob.formSections.jobSearch.display) {
      return null;
    }

    return (
      <div>
        <JobInfo
          app={app}
          acceptedFileTypes={acceptedFileTypes}
          addJob={addJob}
          cancelUpload={actions.cancelUpload}
          delayUpload={actions.delayUpload}
          getFileRejectReason={this.getFileRejectReason}
          getJobCerts={actions.getJobCerts}
          getJobSkills={actions.getJobSkills}
          isQuickPriceJobEnabled={isQuickPriceJobEnabled}
          itemToUpload="Job Description"
          jobLocationSearch={actions.jobLocationSearch}
          onDrop={actions.onDrop}
          orgJobCodeKey={{ display: useJobCodeKey, label: replacement, value: jobDetails.details.org_job_code_key }}
          rejectReason={this.state.fileRejectReason}
          removeJobDescription={actions.removeJobDescription}
          resetFileRejectReason={this.resetFileRejectReason}
          saveJob={actions.saveJob}
          titleJobSearch={actions.titleJobSearch}
          isJdxEnabled={isJdxEnabled}
        />
      </div>
    );
  }

  jobSearchSection() {
    const { actions, addJob } = this.props;
    let orgJobTitle = null;
    let payscaleJobTitle = null;
    const editingJob = addJob && addJob.jobDetails;

    if (addJob.formSections.jobSearch.display && editingJob) {
      orgJobTitle = addJob.orgJobTitle;
      payscaleJobTitle = addJob.jobDetails.PayscaleJobTitle;
    }

    if (addJob.formSections.jobDetails.display && !addJob.formSections.jobSearch.display) {
      return null;
    }

    return (
      <JobTitleSearch
        cancelEditJobTitle={actions.cancelEditJobTitle}
        editJobTitleMode={addJob.editJobTitleMode}
        getJobCerts={actions.getJobCerts}
        getJobSkills={actions.getJobSkills}
        jobCode={addJob.jobCode}
        jobLocationSearch={actions.jobLocationSearch}
        noJobCode={addJob.noJobCode}
        orgJobId={addJob.orgJobId}
        orgJobTitle={orgJobTitle}
        payscaleJobTitle={payscaleJobTitle}
        saveJob={actions.saveJob}
        titleJobSearch={editingJob ? actions.editJobTitleSearch : actions.titleJobSearch}
        workLocationExact={addJob.workLocationExact}
      />
    );
  }

  handleJobSearch() {
    const { actions, addJob } = this.props;

    actions.editJobTitleSearch({
      params: {
        additionalSearch: true,
        jobCode: addJob.jobCode,
        orgJobId: addJob.orgJobId,
        title: addJob.orgJobTitle,
        workLocation: addJob.workLocationExact
      }
    });
  }

  jobTitleSection() {
    const {
      actions,
      addJob,
      app,
      isAdvancedSurveyManagementEnabled,
      jobDetails,
      jobSurveyList,
      surveyDetails
    } = this.props;

    if (addJob.formSections.jobDetails.display && !addJob.formSections.jobSearch.display) {
      return null;
    }

    const onCutSelect = actions.surveyListActions('updateJobMatchDataCut', 'get function');
    const crowdSourcedSurveyCode = `PAY-${app.subsite.toUpperCase()}`;
    // use this crazy legacy thing instead of function imports
    const updateMatch = actions.surveyListActions('updateMatch', 'get function');

    if (addJob.jobDetails && addJob.jobDetails.PayscaleJobTitle) {
      let currency = null;
      let highVariance = false;
      let matchId = null;
      let payRange: any = [];
      let payRangeMax = null;
      let payRangeMin = null;

      if (
        addJob.jobDetails.Reports &&
        addJob.jobDetails.Reports.payReport &&
        addJob.jobDetails.Reports.payReport.reports &&
        addJob.jobDetails.Reports.payReport.reports.basePayReport
      ) {
        const percentile25 = addJob.jobDetails.Reports.payReport.reports.basePayReport.percentile25;
        const percentile50 = addJob.jobDetails.Reports.payReport.reports.basePayReport.percentile50;
        const percentile75 = addJob.jobDetails.Reports.payReport.reports.basePayReport.percentile75;
        currency = addJob.jobDetails.Reports.payReport.reports.basePayReport.currencyFormat;
        if (currency && currency.length > 0) {
          currency = currency.substring(0, currency.indexOf('{'));
          const domParser = new DOMParser();
          currency = domParser.parseFromString(currency, 'text/html').body.textContent;
        }
        payRange = [percentile25, percentile50, percentile75];
        payRangeMin = addJob.jobDetails.Reports.payReport.reports.basePayReport.percentile10;
        payRangeMax = addJob.jobDetails.Reports.payReport.reports.basePayReport.percentile90;
        matchId = addJob.orgJobId ? addJob.orgJobId.toString() : '';
        const qualityReportRating = hasQualityReportRating({
          workLocationExact: addJob.workLocationExact,
          // eslint-disable-next-line @typescript-eslint/camelcase
          payscale_job_info: {
            Reports: addJob.jobDetails.Reports
          }
        });
        highVariance = qualityReportRating === 2;
      }

      // Get the crowdSourceMatch's survey data
      let crowdSourceMatchSurveyData = null;

      if (jobSurveyList && jobSurveyList.items) {
        for (let i = 0; i < jobSurveyList.items.length; i++) {
          let survey = jobSurveyList.items[i];
          if (survey.survey_code.includes(crowdSourcedSurveyCode)) {
            crowdSourceMatchSurveyData = survey;
            break;
          }
        }
      }

      // Set the survey status from the crowd source match
      let crowdSourceSurveyStatus = false;
      if (crowdSourceMatchSurveyData && crowdSourceMatchSurveyData.wgt > 0) {
        // only included if the survey weight is gtr than 0
        crowdSourceSurveyStatus = true;
      }
      let crowdSourceMatchWeight = 1;
      let crowdSourceMatchGeo = 1;
      let crowdSourceMatchAdj = 1;
      if (jobSurveyList && jobSurveyList.items) {
        jobSurveyList.items.forEach((survey: any) => {
          if (survey.survey_code.includes(crowdSourcedSurveyCode)) {
            matchId = survey.match_id;
            crowdSourceMatchWeight = survey.wgt;
            crowdSourceMatchGeo = survey.geo;
            crowdSourceMatchAdj = survey.adj;
          }
        });
      }

      const crowdSourceMatch = {
        adj: crowdSourceMatchAdj,
        crowdSourceSurveyStatus: crowdSourceSurveyStatus,
        geo: crowdSourceMatchGeo,
        highVariance: highVariance,
        jobTasks: addJob.jobDetails.Tasks,
        loadingMatchDetails: false,
        matchId: parseInt(matchId),
        payRange: payRange,
        payRangeScaleMax: payRangeMax,
        payRangeScaleMin: payRangeMin,
        updateMatch: updateMatch,
        weight: crowdSourceMatchWeight
      };

      // TODO: Identify a better solution in identifying a company match
      let companySourceMatch = null;

      if (!isAdvancedSurveyManagementEnabled && jobSurveyList && jobSurveyList.items) {
        jobSurveyList.items.forEach((survey: any) => {
          const pubJobCode = jobDetails.details.org_job_code + jobDetails.details.org_job_code_key;
          const surveyPubJobCode = survey.org_job_code + survey.org_job_code_key;
          if (
            survey.pub_survey_publisher === 'PayScale Company Sourced' &&
            (!survey.approved_status || survey.approved_status.toLowerCase() !== 'suggested') &&
            survey.match_id > 0 &&
            surveyPubJobCode === pubJobCode &&
            jobDetails.details.org_job_id === addJob.orgJobId
          ) {
            const payRangeCompanySource = [survey.base_salary_25th, survey.base_salary_50th, survey.base_salary_75th];
            const payRangeCompanySourceMin = survey.base_salary_10th || survey.base_salary_25th;
            const payRangeCompanySourceMax = survey.base_salary_90th || survey.base_salary_75th;
            const companyData = {
              total_companies: survey.total_companies, // eslint-disable-line @typescript-eslint/camelcase
              total_incumbents: survey.total_incumbents // eslint-disable-line @typescript-eslint/camelcase
            };
            const highVariance = false; // TODO: figure out how high variance works with matches

            let surveyStatus = false;
            if (survey && survey.wgt) {
              if (survey.wgt > 0) {
                // only included if the survey weight is gtr than 0
                surveyStatus = true;
              }
            }

            const { companyMatchDataCuts, companyMatchDataCutsLoading } = jobDetails;
            const surveyDetailsLoading = surveyDetails && surveyDetails.loading;
            let dataCuts, emptyDataCuts;
            if (companyMatchDataCuts) {
              dataCuts = companyMatchDataCuts.surveyJobDataCuts;
              if (!dataCuts) dataCuts = [];

              emptyDataCuts = companyMatchDataCuts.surveyJobEmptyDataCuts;
              if (!emptyDataCuts) emptyDataCuts = [];
            } else {
              dataCuts = [];
              emptyDataCuts = [];
            }

            companySourceMatch = {
              adj: survey.adj,
              companyData: companyData,
              cutId: survey._id || survey.cut_id,
              dataCuts,
              emptyDataCuts,
              geo: survey.geo,
              highVariance: highVariance,
              jobDescription: survey.job_description,
              loadingDetails: companyMatchDataCutsLoading || surveyDetailsLoading,
              matchId: survey.match_id,
              orgJobId: addJob.orgJobId,
              payRange: payRangeCompanySource,
              payRangeScaleMax: payRangeCompanySourceMax,
              payRangeScaleMin: payRangeCompanySourceMin,
              selectedDataCut: survey.job_scope,
              sourceMapId: survey.source_map_id,
              surveyCode: survey.survey_code,
              surveyStatus: surveyStatus,
              title: survey.pub_job_title,
              updateMatch: updateMatch,
              weight: survey.wgt
            };
          }
        });
      }

      const jobTitleMatch: React.ReactNode = (
        <JobCurrentMatches
          app={app}
          companySourceMatch={companySourceMatch}
          crowdSourceMatch={crowdSourceMatch}
          currency={currency}
          editJobTitle={this.handleJobSearch}
          highVariance={highVariance}
          jobCode={addJob.jobCode}
          jobDetails={jobDetails}
          jobSurveyActions={actions.surveyListActions}
          jobSurveyList={jobSurveyList}
          jobTitle={addJob.jobDetails.PayscaleJobTitle}
          loadDataCutsPanel={actions.loadDataCutsPanel}
          onCutSelect={onCutSelect}
          orgJobId={addJob.orgJobId}
          orgJobTitle={addJob.orgJobTitle}
          saveProfilesAnalyzed={actions.saveProfilesAnalyzed}
          surveyDetails={{ ...surveyDetails, actions: actions.getSurveyActions() }}
          titleJobSearch={actions.titleJobSearch}
          updateMatchesAndPay={actions.updateMatchesAndPay}
          workLocationExact={addJob.workLocationExact}
        />
      );

      const jobTitleMatchSearch: React.ReactNode = (
        <JobTitleMatches
          addJob={addJob}
          app={app}
          formSections={addJob.formSections}
          getAllReports={actions.getAllReports}
          getJobCerts={actions.getJobCerts}
          getJobSkills={actions.getJobSkills}
          items={addJob.jobTitles}
          jobDetails={jobDetails}
          onDropDelayed={actions.onDropDelayed}
          saveJob={actions.saveJob}
          selectJob={actions.selectJob}
          setInitialJobDetails={actions.setInitialJobDetails}
          setJobMatchSaving={actions.setJobMatchSaving}
          setJobMatchError={actions.setJobMatchError}
        />
      );
      let matchContainerClassName = 'job-matches__match-container';
      if (addJob.formSections.jobTitleMatches && addJob.formSections.jobTitleMatches.display) {
        matchContainerClassName += ' job-matches__match-container--transition';
      }

      return (
        <div className={matchContainerClassName}>
          <div className="job-matches__match-area">{jobTitleMatch}</div>
          <div className="job-matches__match-search-area">{jobTitleMatchSearch}</div>
        </div>
      );
    } else if (!addJob.editMode || addJob.formSections.jobTitleMatches.display) {
      return (
        <div className="job-matches__match-container-add">
          <JobTitleMatches
            addJob={addJob}
            app={app}
            formSections={addJob.formSections}
            getAllReports={actions.getAllReports}
            getJobCerts={actions.getJobCerts}
            getJobSkills={actions.getJobSkills}
            items={addJob.jobTitles}
            jobDetails={jobDetails}
            onDropDelayed={actions.onDropDelayed}
            saveJob={actions.saveJob}
            selectJob={actions.selectJob}
            setInitialJobDetails={actions.setInitialJobDetails}
            setJobMatchSaving={actions.setJobMatchSaving}
            setJobMatchError={actions.setJobMatchError}
          />
        </div>
      );
    }

    return null;
  }

  onDragEnter(e: Event) {
    const { actions, addJob } = this.props;
    if (addJob.enableJodDropZone) {
      e.preventDefault();
      actions.onDragEnter();
    }
  }

  onDragLeave(e: Event) {
    const { actions } = this.props;
    e.preventDefault();
    actions.onDragLeave();
  }

  cancelUpload() {
    const { actions } = this.props;
    actions.cancelUpload();
  }

  onDrop(file: File) {
    this.setState({ fileRejectReason: '' });
    const { actions, addJob } = this.props;
    if (addJob.editMode === false) {
      actions.delayUpload(file);
    }

    actions.onDrop(file, addJob.orgJobId);
  }

  getFileRejectReason(fileRejections: { errors: { code: string }[] }[]) {
    if (fileRejections[0].errors[0].code) {
      this.setState({ fileRejectReason: fileRejections[0].errors[0].code });
    }
  }

  resetFileRejectReason() {
    this.setState({ fileRejectReason: '' });
  }

  render() {
    const {
      actions,
      addJob,
      addJobStructureList,
      addJobUpdatedDetails,
      app,
      careerLevels,
      history,
      jobCertifications,
      jobDetails,
      jobFamilies,
      jobSurveyList,
      marketRateChart,
      showYearsExperienceLabelUpdate,
      skillsByJobList,
      suggestCareer,
      suggestFamily,
      surveyDetails,
      isJdxEnabled
    } = this.props;

    const acceptedFileTypes = ['.RTF', '.TXT', '.DOC', '.DOCX', '.PDF'];
    let dragAndDropScreenText = 'Drop to upload the file';
    if (addJob.showDropZone && addJob.jobDescriptionSuccess) {
      dragAndDropScreenText = 'Drop to replace the existing file';
    }

    let annualOrHourly = 'annual';
    if (
      jobDetails &&
      jobDetails.details &&
      jobDetails.details.payscale_job_info &&
      jobDetails.details.payscale_job_info.annualOrHourly
    ) {
      annualOrHourly = jobDetails.details.payscale_job_info.annualOrHourly;
    }
    let currency = 'USD';
    if (jobDetails && jobDetails.details && jobDetails.details.job_currency) {
      currency = jobDetails.details.job_currency;
    }

    let marketBaseSalary50th = 0;

    if (addJob && addJob.recommendGrade && addJob.recommendGrade.market_base_salary_50th) {
      marketBaseSalary50th = addJob.recommendGrade.market_base_salary_50th;
    } else if (jobDetails && jobDetails.details && jobDetails.details.market_base_salary_50th) {
      marketBaseSalary50th = jobDetails.details.market_base_salary_50th;
    }

    let compositePayRange = null;
    if (
      addJobUpdatedDetails &&
      addJobUpdatedDetails.marketBaseSalary25th &&
      addJobUpdatedDetails.marketBaseSalary75th &&
      addJobUpdatedDetails.marketBaseSalary50th
    ) {
      compositePayRange = {
        marketBaseSalary25th: addJobUpdatedDetails.marketBaseSalary25th,
        marketBaseSalary50th: addJobUpdatedDetails.marketBaseSalary50th,
        marketBaseSalary75th: addJobUpdatedDetails.marketBaseSalary75th
      };
    }
    // Fall back on the base chart data from job details
    else if (
      jobDetails &&
      jobDetails.baseChartData &&
      jobDetails.baseChartData.data &&
      jobDetails.baseChartData.data['25th'] &&
      jobDetails.baseChartData.data['50th'] &&
      jobDetails.baseChartData.data['75th']
    ) {
      compositePayRange = {
        marketBaseSalary25th: jobDetails.baseChartData.data['25th'],
        marketBaseSalary50th: jobDetails.baseChartData.data['50th'],
        marketBaseSalary75th: jobDetails.baseChartData.data['75th']
      };
    }

    const isJobTitleMatchOpen = addJob.formSections.jobTitleMatches.display;
    const showJobMatchHeader = !addJob.jobMatchSaving && !addJob.jobMatchError && addJob.detailsFullyLoaded;
    const showLoading = (addJob.jobMatchSaving && !addJob.jobMatchError) || !addJob.detailsFullyLoaded;
    const showJobDetails =
      !isJobTitleMatchOpen && !addJob.jobMatchSaving && !addJob.jobMatchError && addJob.detailsFullyLoaded;
    const showJobRibbon =
      (addJob.formSections.jobSearch.display || !addJob.formSections.jobDetails.display) && addJob.detailsFullyLoaded;

    return (
      <SharedSlideoutWithRouter
        isOpen={addJob.panelVisible}
        className={`add-edit-job-slideout ${this.getJobStateClass()} ${this.getJobTransitionClass()}`}
        panelClassName="add-edit-job-slideout__panel"
        handleCloseSlideout={this.close.bind(this)}
        useCloseButton={true}
        onOpenFinish={actions.editJobSlideoutLoad}
        onCloseFinish={actions.loadDetailsAfterSlideoutClose}
        animationDelayMs={0}
        endpoint={addJob.editMode ? 'edit' : 'add'}
      >
        <StickyContainer className="row">
          <div className="col-xs-12">
            {addJob.orgJobId === null && <LoadingIndicator loading={addJob.jobIdLoading === null} />}
            {this.basicJobInfoSection()}
            {showJobRibbon && (
              <div className="sticky--header">
                <div className="add-job__job-ribbon-container">
                  <JobRibbon
                    addJob={addJob}
                    app={app}
                    currency={currency}
                    editJobTitle={actions.editJobTitle}
                    payRange={compositePayRange}
                  />
                </div>
              </div>
            )}
            {addJob.jobMatchError && (
              <p className="add-job__match-error">Oops! Something went wrong. Please reload the page and try again.</p>
            )}
            {showJobMatchHeader && (
              <div className="add-job__match-header">
                {this.jobSearchSection()}
                {this.jobTitleSection()}
              </div>
            )}
            {showLoading && <LoadingIndicator className="add-job__job-match-saving-logo" />}
            {showJobDetails && (
              <div className="add-job__form-container">
                <InfoContainer
                  acceptedFileTypes={acceptedFileTypes}
                  addJob={addJob}
                  app={app}
                  careerLevels={careerLevels}
                  certificationsSearch={actions.certificationsSearch}
                  delayUpload={actions.delayUpload}
                  dragAndDropScreenText={dragAndDropScreenText}
                  editJobTitle={actions.editJobTitle}
                  editMode={addJob.editMode}
                  getAllReports={actions.getAllReports}
                  getFileRejectReason={this.getFileRejectReason}
                  itemToUpload="Job Description"
                  jobCertifications={jobCertifications}
                  jobDescription={addJob.jobDescription}
                  jobDetails={jobDetails}
                  jobFamilies={jobFamilies}
                  jobSurveyActions={actions.surveyListActions}
                  jobSurveyList={jobSurveyList}
                  loadDataCutsPanel={actions.loadDataCutsPanel}
                  onCutSelect={actions.onCutSelect}
                  onDrop={actions.onDrop}
                  orgJobId={addJob.orgJobId}
                  rejectReason={this.state.fileRejectReason}
                  removeJobDescription={actions.removeJobDescription}
                  resetFileRejectReason={this.resetFileRejectReason}
                  saveCareerLevel={actions.saveCareerLevel}
                  saveJob={actions.saveJob}
                  saveJobAndUpdatePay={actions.saveJobAndUpdatePay}
                  saveJobFamily={actions.saveJobFamily}
                  saveProfilesAnalyzed={actions.saveProfilesAnalyzed}
                  setInitialJobDetails={actions.setInitialJobDetails}
                  showYearsExperienceLabelUpdate={showYearsExperienceLabelUpdate}
                  skillsByJobList={skillsByJobList}
                  skillsSearch={actions.skillsSearch}
                  state={this.state}
                  suggestCareer={suggestCareer}
                  suggestFamily={suggestFamily}
                  surveyDetails={{ ...surveyDetails, actions: actions.getSurveyActions() }}
                  updateMatch={actions.updateMatch}
                  updatePayReport={actions.updatePayReport}
                  quickUpdateJobDetailsAndPay={actions.quickUpdateJobDetailsAndPay}
                  isJdxEnabled={isJdxEnabled}
                />

                <GradeContainer
                  addJob={addJob}
                  addJobStructureList={addJobStructureList}
                  changePayStructure={actions.changePayStructure}
                  getMarketRateChart={actions.getMarketRateChart}
                  history={history}
                  marketBaseSalary50th={marketBaseSalary50th}
                  marketRateChart={marketRateChart}
                  saveJob={actions.saveJob}
                  saveJobGrade={actions.saveJobGrade}
                  updatePayReport={actions.updatePayReport}
                />
                <Footer
                  annualOrHourly={annualOrHourly}
                  app={app}
                  currency={currency}
                  jobSavingStatus={addJob.jobSavingStatus}
                  marketBaseSalary50th={addJobUpdatedDetails.marketBaseSalary50th}
                  oldMarketBaseSalary50th={addJob.initialBaseSalary}
                  loadingBasePay={addJob.payReportLoading}
                />
              </div>
            )}
          </div>
        </StickyContainer>
      </SharedSlideoutWithRouter>
    );
  }
};

const mapStateToProps = ({
  addJob,
  addJobStructureList,
  addJobUpdatedDetails,
  app,
  careerLevels,
  features,
  jobCertifications,
  jobDetails,
  jobFamilies,
  jobSurveyList,
  marketRateChart,
  session,
  skillsByJobList,
  suggestCareer,
  surveyDetails,
  suggestFamily
}: any) => {
  return {
    addJob: addJob,
    addJobStructureList: addJobStructureList,
    addJobUpdatedDetails: addJobUpdatedDetails,
    app: app ? app : session,
    careerLevels: careerLevels,
    isAdvancedSurveyManagementEnabled: isFeatureEnabled(features.flags, 'surveyFlag').isEnabled,
    isQuickPriceJobEnabled: isFeatureEnabled(features.flags, 'quickPriceJob').isEnabled,
    jobCertifications: jobCertifications,
    jobDetails: jobDetails,
    jobFamilies: jobFamilies,
    jobSurveyList: jobSurveyList,
    marketRateChart: marketRateChart,
    showYearsExperienceLabelUpdate: isFeatureEnabled(features.flags, 'experienceLabelsUpdate').isEnabled,
    skillsByJobList: skillsByJobList,
    suggestCareer: suggestCareer,
    surveyDetails: surveyDetails,
    suggestFamily: suggestFamily,
    useJobCodeKey: session && session.organization ? session.organization.useJobCodeKey : true,
    replacementTokens: session && session.replacementTokens ? session.replacementTokens : null,
    isJdxEnabled: isFeatureEnabled(features.flags, 'jdx-integration').isEnabled
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  actions: bindActionCreators(
    {
      ...addJobActions,
      ...addJobUpldatedDetailsActions,
      ...careerLevelsActions,
      ...gradeChartActions,
      ...jobCertificationsActions,
      ...jobFamilyActions,
      ...jobSkillsActions,
      ...structureListActions,
      ...suggestCareerActions,
      ...suggestFamilyActions,
      ...surveyActions,
      surveyListActions,
      getSurveyActions,
      saveProfilesAnalyzed,
      loadJobDetails,
      loadDetailsChart,
      resetScroll,
      ...jobActions
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddEditJobSlideout));
